import { DataService } from '../Shared/DataService';
import { useEffect, useState } from 'react';

const useFetch = (entity:string, method:string, para?:Object) => {
    const ds = new DataService();
    const [data,setData] = useState([]);


    useEffect(() => {
        debugger;
        ds.Get(entity, method, para)
        .then(response => response.json())
        .then(data => {
            data = data.sort(function (a: any, b: any) {
                return new Date(b.callDate).getTime() - new Date(a.callDate).getTime();
            });
            console.log("hook= " + data);
            setData(data);
        });
    }, [entity, method]);

    return {data};

}

export default useFetch;